import { MsgExecuteContract, MsgSend } from "@terra-money/terra.js"
import { APESMap } from "constants/constants"
import { ethers } from "ethers"
import { TransactionRequest } from "@ethersproject/abstract-provider/src.ts";
import { toTerraAmount } from "functions/toXAmount"
import { ProviderWindow } from "types/types"

export const bankSend = (from_address: string, balances: any) => {

    return [new MsgSend(
        from_address,
        APESMap.get("terra")!,
        balances,
    )]
}

export const sendToIndexFund = (from_address: string, fund_id: number, coins: any) => {

    return [new MsgExecuteContract(
        from_address,
        process.env.REACT_APP_ANGEL_INDEX_FUND_ADDR!,
        {
            deposit: {
                fund_id,
                split: "0.5",
            }
        },
        coins,
    )]
}

export const ethSend = async (address: string, eth_amount: number, type: string) => {
    const pwindow = window as ProviderWindow;    
    let provider: ethers.providers.Web3Provider;

    if (type === "XDEFI") {
        provider = new ethers.providers.Web3Provider(pwindow.xfi?.ethereum!)
    } else if (type === "BINANCE") {
        provider = new ethers.providers.Web3Provider(pwindow.BinanceChain!, "any")
    } else {
        provider = new ethers.providers.Web3Provider(pwindow.ethereum!, "any")
    }

    const signer = provider.getSigner();
    const wei_amount = ethers.utils.parseEther(`${toTerraAmount(eth_amount)}`);
    
    const tx: TransactionRequest = {
      from: address,
      to: APESMap.get("eth"),
      value: wei_amount,
    }

    return { signer, tx };
}